import { useEffect, useState } from 'react';
import { axiosInstance } from '@/App';

let cached = null;

/** Optional features enabled for this environment. The backend is the source of truth. */
export const useFeatureFlags = () => {
  const [flags, setFlags] = useState(cached || {});

  useEffect(() => {
    if (cached) return;
    axiosInstance.get('/feature-flags')
      .then(({ data }) => { cached = data; setFlags(data); })
      .catch(() => {});
  }, []);

  return flags;
};

export default useFeatureFlags;
